var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6127 6.31824L9.6767 2.38224L1.6387 10.4212L1.5217 10.5492C1.33563 10.7708 1.19984 11.0301 1.1237 11.3092L0.0177042 15.3642L0.00270438 15.4442C-0.00574794 15.5252 0.00568315 15.607 0.0360055 15.6825C0.0663278 15.758 0.114625 15.825 0.176703 15.8776C0.238782 15.9302 0.312766 15.9669 0.392232 15.9844C0.471698 16.002 0.554244 15.9998 0.632704 15.9782L4.6867 14.8722L4.8517 14.8192C5.1227 14.7192 5.3697 14.5622 5.5747 14.3572L13.6127 6.31824ZM15.1807 0.815243C14.9223 0.556782 14.6155 0.351757 14.2778 0.211876C13.9401 0.0719958 13.5782 0 13.2127 0C12.8472 0 12.4853 0.0719958 12.1476 0.211876C11.8099 0.351757 11.5031 0.556782 11.2447 0.815243L10.3837 1.67524L14.3197 5.61124L15.1797 4.75124L15.3107 4.61124C15.7739 4.07972 16.0181 3.39222 15.9939 2.68762C15.9698 1.98302 15.6792 1.31383 15.1807 0.815243Z",
    fill: "#686F7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.f4abcb1b3ab2be0c52451ff0d5a1c671.svg";
export { ForwardRef as ReactComponent };